import { IonCheckbox } from '@ionic/react';
import React, { useState } from 'react';
import { FieldError, NormalText, SmallText, StrongText } from '../common';
import { useSelector } from 'react-redux';
import { getConfig } from '../../appConfig';
import Basket from '../../lib/basket';
import './index.css';

const isAlcoholItem = (item) => {
		if (!item) {
			return false;
		}
		const itemRichData = item.itemRichData || {};
		return Boolean(itemRichData.containsAlcohol);
	};

const getAgeRestrictionMessage = (profile, message) => {
	if (!getConfig()?.flags?.showAgeRestrictionBanner) {
		return null;
	}
	const ageRestrictionConfig = getConfig()?.restrictions;
	if (!ageRestrictionConfig?.age) {
		return null;
	}

	const ageRestrictionMessages = ageRestrictionConfig?.ageRestrictionMessages;
	const profileLanguage = profile?.locale || 'en';
	const ageRestrictionMessage = message || ageRestrictionMessages?.[profileLanguage];
	if (!ageRestrictionMessage) {
		return null;
	}

	const singleBasketItems = Basket.getItems() || [];
	const multiBasketItems = (Basket.multi_basket_items || []).flatMap((order) => order?.items || []);
	const basketItems = [...singleBasketItems, ...multiBasketItems];

	const hasAlcoholItems = basketItems.some((basketItem) => {
		if (isAlcoholItem(basketItem?.item)) {
			return true;
		}

		const selectedChoices = basketItem?.selectedChoices ? basketItem.selectedChoices.flat(2) : [];
		return selectedChoices.some((choice) => isAlcoholItem(choice));
	});

	return hasAlcoholItems ? ageRestrictionMessage : null;
};

export const isAgeRestrictionSatisfied = (profile) => Basket.getAgeRestrictionConfirmed() || !getAgeRestrictionMessage(profile);

const AgeRestrictionWarning = ({ message, error, onConfirmChange, __ }) => {
	const profile = useSelector((state) => state.profile.profile);
	const [confirmed, setConfirmed] = useState(Basket.getAgeRestrictionConfirmed());
	const handleConfirmChange = (checked) => {
		setConfirmed(checked);
		Basket.setAgeRestrictionConfirmed(checked);
		onConfirmChange && onConfirmChange(checked);
	};

	const ageRestrictionMessage = getAgeRestrictionMessage(profile, message);
	if (!ageRestrictionMessage) {
		return null;
	}
	const age = getConfig().restrictions.min_registration_age || 18;

	return (
		<div className={`box-wrapper age-restriction-warning${error ? ' age-restriction-warning-error' : ''}`}>
			<div className="age-restriction-warning-header">
				<div className="age-restriction-warning-badge">{age}+</div>
				<div className="age-restriction-warning-content">
					<StrongText className="age-restriction-warning-title">{__('Your order contains alcohol')}</StrongText>
					<SmallText className="age-restriction-warning-text">{__(ageRestrictionMessage)}</SmallText>
				</div>
			</div>
			<div className="age-restriction-warning-confirm" onClick={() => handleConfirmChange(!confirmed)}>
				<IonCheckbox checked={confirmed} />
				<NormalText className="age-restriction-warning-confirm-text">
					{__("I confirm I can provide a valid form of ID. I understand that if I can't, I won't be served alcoholic items and won't be entitled to a refund for them.")}
				</NormalText>
			</div>
			{error && <FieldError className="field-error" value={__('Please tick to confirm before paying')} />}
		</div>
	);
};

export default AgeRestrictionWarning;
